import React from 'react';
import { Progress, Space, Typography } from 'antd';
import { TierBadge } from './TierBadge';

const { Text } = Typography;

type Tier = 'clean' | 'suspect' | 'flagged' | 'quarantined' | null | undefined;

interface QualityScoreDisplayProps {
    score: number | null | undefined;
    tier: Tier;
    size?: 'small' | 'large';
}

const tierColor = (tier: Tier): string => {
    switch (tier) {
        case 'clean':
            return '#52c41a';
        case 'suspect':
            return '#faad14';
        case 'flagged':
            return '#fa8c16';
        case 'quarantined':
            return '#f5222d';
        default:
            return '#bfbfbf';
    }
};

export const QualityScoreDisplay: React.FC<QualityScoreDisplayProps> = ({
    score,
    tier,
    size = 'small',
}) => {
    if (score === null || score === undefined) {
        return <Text type="secondary">—</Text>;
    }

    if (size === 'small') {
        return (
            <Space size={8} wrap={false}>
                <Text strong style={{ color: tierColor(tier), whiteSpace: 'nowrap' }}>
                    {score.toFixed(1)}
                </Text>
                <TierBadge tier={tier} />
            </Space>
        );
    }

    return (
        <Space direction="vertical" size={8} style={{ width: '100%' }}>
            <Progress
                type="circle"
                percent={Math.max(0, Math.min(100, score))}
                strokeColor={tierColor(tier)}
                format={() => (
                    <Space direction="vertical" size={0} align="center">
                        <Text strong style={{ fontSize: 24, color: tierColor(tier) }}>
                            {score.toFixed(0)}
                        </Text>
                        <Text type="secondary" style={{ fontSize: 12 }}>
                            / 100
                        </Text>
                    </Space>
                )}
                size={120}
            />
            <div style={{ textAlign: 'center' }}>
                <TierBadge tier={tier} />
            </div>
        </Space>
    );
};
